import { render, staticRenderFns } from "./ItemPromotion.vue?vue&type=template&id=96039a5e&"
import script from "./ItemPromotion.vue?vue&type=script&lang=js&"
export * from "./ItemPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports